import ManagerRepository from './ManagerRepository';
import Observable from 'coreClasses/patterns/observable/Observable';

/**
 * Represents Manager
 */
abstract class Manager extends Observable {
	protected managerRepository: ManagerRepository;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 */
	constructor(managerRepository: ManagerRepository) {
		super();

		this.managerRepository = managerRepository;
	}
}

export default Manager;
